import { render, staticRenderFns } from "./withdrawalDetailModal.vue?vue&type=template&id=1f88d003&scoped=true&"
import script from "./withdrawalDetailModal.vue?vue&type=script&lang=js&"
export * from "./withdrawalDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalDetailModal.vue?vue&type=style&index=0&id=1f88d003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88d003",
  null
  
)

export default component.exports